import styled from 'styled-components';

export const LightboxVideo = styled.video.attrs({
    'data-testid': 'lightbox-video-element',
})`
    position: absolute;
    max-height: 80%;
    max-width: 80%;
`;
